import {Button, ModalCard} from "@vkontakte/vkui";
import {observer} from "mobx-react-lite";
import React from 'react';
import GameStore from "../../store/game";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {Icon56CancelCircleOutline} from "@vkontakte/icons";
import {InviteButton} from "../../components/InviteButton/InviteButton";
import {
    MODAL_CARD_CLASS,
    MODAL_HEADER_CLASS,
    MODAL_SECONDARY_BUTTON_CLASS
} from "../modalStyles";

// Модальное окно, которые мы показываем после того как игрок проиграл
export const FailedFinishGameModal = observer(({nav}) => {
    const routeNavigator = useRouteNavigator();

    const subheader = (
        <div className={"text-center text-gray-700"}>
            <p>Загаданное слово было: <span className={"font-bold uppercase tracking-widest text-gray-900"}>{GameStore.word}</span></p>
            <p>Не расстраивайтесь, повезет в следующий раз!</p>
        </div>
    );

    return (
        <ModalCard
            nav={nav}
            onClose={() => routeNavigator.hideModal()}
            className={MODAL_CARD_CLASS}
            icon={<Icon56CancelCircleOutline className={"text-brand-danger"} />}
            header={<span className={MODAL_HEADER_CLASS}>Поражение!</span>}
            subheader={subheader}
            actions={
                <div className={"flex flex-col w-full gap-2"}>
                    <InviteButton />
                    <Button
                        size="l"
                        mode="secondary"
                        className={MODAL_SECONDARY_BUTTON_CLASS}
                        onClick={() => routeNavigator.hideModal()}
                    >
                        Закрыть
                    </Button>
                </div>
            }
        />
    )
});
